module.exports = __webpack_public_path__ + "img/pia-logo.94d8309f.png";